export interface OwnProps {
  label: string
  onHandlePrimaryButton?: any
  onHandleSecondaryButton?: any
  color: string
  icon?: any
  resetElements?: (reset: boolean) => void
  reset?: boolean
  isSelected?: boolean
  headerButton?: boolean
  disabled?: boolean
  isFocus?: boolean
}

export const buttonConfiguration = ['default', 'primary']

export interface State {
  reset: boolean
}

export type Props = OwnProps